import React, { useMemo } from 'react'

import { useVersioning } from 'modules/versioning'

import { useAnnotationStatusFilter } from './hooks'
import { AnnotationQueryVariablesContext } from './context'

interface AnnotationQueryVariablesProviderProps {
  shareIdentifier: string
  permanentPageId: string
  permanentArtboardId?: string
}

export const AnnotationQueryVariablesProvider: React.FC<AnnotationQueryVariablesProviderProps> = ({
  children,
  permanentArtboardId,
  permanentPageId,
  shareIdentifier,
}) => {
  const { versionIdentifier } = useVersioning()
  const {
    annotationQuerySort,
    annotationQueryStatus,
  } = useAnnotationStatusFilter()

  const value = useMemo(
    () => ({
      shareIdentifier,
      permanentArtboardId,
      permanentPageId,
      versionIdentifier: versionIdentifier!,
      annotationStatus: annotationQueryStatus,
      annotationSort: annotationQuerySort,
    }),
    [
      annotationQuerySort,
      annotationQueryStatus,
      permanentArtboardId,
      permanentPageId,
      shareIdentifier,
      versionIdentifier,
    ]
  )

  return (
    <AnnotationQueryVariablesContext.Provider value={value}>
      {children}
    </AnnotationQueryVariablesContext.Provider>
  )
}
